import type { BackgroundValue } from '@elfsight/configurator-contracts';
import { getGradientValue } from '@elfsight/widget-ui';

export function parseBackgroundValue(
  background: BackgroundValue | undefined
): string | undefined {
  let value: string | undefined = undefined;

  if (!background) {
    return value;
  }

  if (background.type === 'color') {
    value = background.color;
  }

  if (background.type === 'gradient') {
    value = getGradientValue(background.gradient);
  }

  return value;
}
